import { useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const gold = "#c8a96e";
const dark = "#0f0d0a";

export default function AuthPage() {
  const { login } = useAuth();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setError(""); setLoading(true);
    try {
      const url = mode === "login" ? "/api/auth/login" : "/api/auth/register";
      const { data } = await axios.post(url, form);
      login(data.token, data.user);
    } catch (err) {
      setError(err.response?.data?.error || "حدث خطأ، حاول مجدداً");
    }
    setLoading(false);
  }

  const inp = {
    width: "100%", boxSizing: "border-box",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 10, padding: "13px 16px",
    color: "#fff", fontSize: 15, outline: "none",
    marginBottom: 14, direction: "ltr", fontFamily: "inherit",
  };

  return (
    <div style={{ minHeight: "100vh", background: dark, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Segoe UI', Tahoma, sans-serif", direction: "rtl" }}>
      <div style={{ width: "100%", maxWidth: 420 }}>

        {/* شعار */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 10 }}>◈</div>
          <h1 style={{ color: gold, margin: 0, fontSize: 28, fontWeight: 800, letterSpacing: 2 }}>دومين برو</h1>
          <p style={{ color: "#555", margin: "8px 0 0", fontSize: 14 }}>منصة إدارة استثمارات الدومينات</p>
        </div>

        {/* البطاقة */}
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,169,110,0.2)", borderRadius: 20, padding: "32px 28px" }}>

          {/* تبديل وضع */}
          <div style={{ display: "flex", background: "rgba(0,0,0,0.3)", borderRadius: 10, padding: 4, marginBottom: 28 }}>
            {[["login", "تسجيل الدخول"], ["register", "حساب جديد"]].map(([m, l]) => (
              <button key={m} onClick={() => { setMode(m); setError(""); }}
                style={{ flex: 1, padding: "10px", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 600, transition: "all .2s", fontFamily: "inherit",
                  background: mode === m ? gold : "transparent",
                  color: mode === m ? dark : "#666" }}>
                {l}
              </button>
            ))}
          </div>

          {mode === "register" && (
            <input placeholder="الاسم الكامل" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              style={{ ...inp, direction: "rtl" }} />
          )}

          <input placeholder="البريد الإلكتروني" type="email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            style={inp} />

          <input placeholder="كلمة المرور" type="password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            style={inp} />

          {error && (
            <div style={{ background: "rgba(196,124,124,0.15)", border: "1px solid rgba(196,124,124,0.3)", borderRadius: 8, padding: "10px 14px", color: "#c47c7c", fontSize: 13, marginBottom: 16, textAlign: "center" }}>
              {error}
            </div>
          )}

          <button onClick={handleSubmit} disabled={loading}
            style={{ width: "100%", background: loading ? "#444" : gold, color: dark, border: "none", borderRadius: 10, padding: 15, fontWeight: 800, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", transition: "all .2s", fontFamily: "inherit" }}>
            {loading ? "جارٍ التحميل..." : mode === "login" ? "دخول ◈" : "إنشاء الحساب ◈"}
          </button>
        </div>

        <p style={{ textAlign: "center", color: "#444", fontSize: 12, marginTop: 24 }}>
          بياناتك محفوظة بأمان على السيرفر
        </p>
      </div>
    </div>
  );
}
